import { FormMode } from 'common/constants/enums';
import { AggPageFormState } from 'context/page-form-context';
import { AggPageState } from 'context/pages-context';

import { BuilderVersion } from '../../../../common/interfaces/page-builder';
import { PageTitle } from '../../../common/partials/PageTitle/PageTitle';
import { PageForm } from '../../page-form/page-form';
import { PageBuilderV2 } from '../page-builder-v2';

interface Props {
  builderVersion?: BuilderVersion
}

export const CreatePage = ({ builderVersion = BuilderVersion.V1 }: Props) => {
  return (
    <div className="flex-column">
      {builderVersion === BuilderVersion.V1 && (
        <div className="d-flex align-center mb-20">
          <PageTitle title="Add new" withReturn />
        </div>
      )}
      {builderVersion === BuilderVersion.V2 && <PageBuilderV2 formMode={FormMode.CREATE} isV2Enabled />}
      {builderVersion === BuilderVersion.V1 && <AggPageState>
        <AggPageFormState>
          <PageForm components={[]} formMode={FormMode.CREATE} />
        </AggPageFormState>
      </AggPageState>}

    </div>
  );
};
